(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["koeling-form-feedback"] && !Shopify.designMode) return;
  try {
    (() => {
    const revealFeedback = () => {
      if (window.Shopify?.designMode) return;
      const messages = [...document.querySelectorAll('[data-hk-form-feedback]')];
      if (!messages.length) return;
      let fragment = '';
      try { fragment = decodeURIComponent(window.location.hash.slice(1)); } catch {}
      const message = messages.find((element) => element.id === fragment || element.dataset.hkFormId === fragment) ?? messages[0];
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!message.isConnected || !message.getClientRects().length) return;
          message.focus({ preventScroll: true });
          message.scrollIntoView({ behavior: 'instant', block: 'start' });
        });
      });
    };
    if (document.readyState === 'complete') revealFeedback();
    else window.addEventListener('pageshow', revealFeedback, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
